export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11190_VIEW_FOCUS_DETAILS': 'View Focus Details'
};
